import FloorplansService from '@/services/floorplans';
import Parser from '@/services/parsers/index';

const fetchFloorplans = async ({ commit, dispatch, rootState }) => {
  const projectId = rootState.project.adhocId;
  const awsId = rootState.project.awsId;

  try {
    let fetchedFloorplans = [];
    // if (rootState.project.forPublic) {
      fetchedFloorplans = await FloorplansService.fetchFromAWS(awsId);
    // } else {
      // fetchedFloorplans = await FloorplansService.fetchAllocationsFromAWS(
    //     awsId,
    //     rootState.user.token
    //   );
    // }
    const fetchedAssets = await FloorplansService.fetchFromADhoc(projectId);
    const floorplanList = Parser.adhocParser.parseFloorplans(fetchedFloorplans.data, fetchedAssets.data.plans);
    const floorList = [];
    let sizeMin = 9999;
    let sizeMax = 0;
    const typeList = [];
    floorplanList.forEach((floorplan) => {
      if (parseInt(floorplan.interior, 10) < sizeMin) {
        sizeMin = parseInt(floorplan.interior, 10);
      }
      if (parseInt(floorplan.interior, 10) > sizeMax) {
        sizeMax = parseInt(floorplan.interior, 10);
      }
      const typeSlug =
        Parser.adhocParser.bedsToTypeSlug(floorplan.beds) +
        Parser.adhocParser.densToTypeSlug(floorplan.dens);
      if (!typeList.includes(typeSlug)) {
        typeList.push(typeSlug);
      }
      floorplan.suites.forEach((suite) => {
        if (!floorList.includes(parseInt(suite.floor,10))) {
          floorList.push(parseInt(suite.floor,10));
        }
      });
    });
    floorList.sort((a, b) => a - b);
    const floorMin = floorList[0];
    const floorMax = floorList[floorList.length - 1];
    const filters = {
      searchString: '',
      typeList: typeList.map(type => ({
        label: Parser.adhocParser.parseTypeSlug(type),
        slug: type,
        active: false
      })),
      collectionList: [
        {
          label: 'City Scape',
          slug: 'cityscape',
          active: false
        },
        {
          label: 'Sea Loge',
          slug: 'sealoge',
          active: false
        },
        {
          label: 'Summer Wind',
          slug: 'summerwind',
          active: false
        },
        {
          label: 'Skye',
          slug: 'skye',
          active: false
        },
      ],
      exposureList: [
        {
          label: 'North',
          slug: 'n',
          active: false
        },
        {
          label: 'East',
          slug: 'e',
          active: false
        },
        {
          label: 'South',
          slug: 's',
          active: false
        },
        {
          label: 'West',
          slug: 'w',
          active: false
        },
      ],
      bathList: [],
      sqftRange: {
        min: sizeMin,
        max: sizeMax,
        default: {
          min: sizeMin,
          max: sizeMax
        }
      },
      floorRange: {
        min: floorMin,
        max: floorMax,
        default: {
          min: floorMin,
          max: floorMax
        }
      }
    };
    filters.typeList.sort((a, b) => {
      if (a.label.toUpperCase() < b.label.toUpperCase()) {
        return -1;
      }
      if (a.label.toUpperCase() > b.label.toUpperCase()) {
        return 1;
      }
      return 0;
    });
    commit('setFloorplanList', floorplanList);
    commit('setFloorList', floorList);
    commit('setFilters', filters);
    dispatch('applySessionedFavourites');
    commit('setAppReady', null, { root: true });
  } catch (error) {
    console.error(error);
  }
};

const applySessionedFavourites = ({ state, rootState, commit }) => {
  const storedFavouritedList = localStorage.getItem(`blackline-${rootState.project.adhocId}-favouritedIdList`);
  if (storedFavouritedList) {
    let favouritedIdList = storedFavouritedList.split(',');
    favouritedIdList = favouritedIdList.filter(id =>
      state.list.find(floorplan => floorplan.id === id)
    );
    commit('setFavouritedIdList', favouritedIdList);
    state.favouritedIdList.forEach((floorplanId) => {
      commit('setFloorplanFavourited', floorplanId);
    });
  }
};

const toggleFloorplanFavourited = ({ state, rootState, commit }, floorplanId) => {
  commit('setFloorplanFavourited', floorplanId);
  const toggledFloorplan = state.list.find(floorplan => floorplan.id === floorplanId);
  if (toggledFloorplan.favourited) {
    state.favouritedList = state.favouritedIdList.push(floorplanId);
    localStorage.setItem(`blackline-${rootState.project.adhocId}-favouritedIdList`, state.favouritedIdList);
  } else {
    state.favouritedIdList = state.favouritedIdList
      .filter(favouriteId => favouriteId !== floorplanId);
    localStorage.setItem(`blackline-${rootState.project.adhocId}-favouritedIdList`, state.favouritedIdList);
  }
};

const reset = ({ commit }) => {
  commit('setFloorplanList', []);
};

const clearFavourites = ({ state, dispatch }) => {
  state.list.forEach((plan) => {
    if (plan.favourited) {
      dispatch('toggleFloorplanFavourited', plan.id)
    }
  })
};

export default {
  fetchFloorplans,
  applySessionedFavourites,
  toggleFloorplanFavourited,
  reset,
  clearFavourites
};



// WEBPACK FOOTER //
// ./src/store/modules/floorplans/actions.js